module.exports = __webpack_public_path__ + "f9ab79747dcea3d14894591f6066e0c5.svg";